module.exports = __webpack_public_path__ + "static/media/portfolio-item-in-page.20bafa5f.png";